import { useState } from "react";
import { useTranslation } from 'react-i18next';
import SimpleHeader from "../../components/layout/SimpleHeader";
import TabItem from "../../components/statistics/TabItem";
import List from "../../components/statistics/text/List";
import Summary from "../../components/statistics/text/Summary";

export enum TextContents {
  Summary,
  List
}

const StatisticsText = () => {
  const { t } = useTranslation();
  const [content, setContent] = useState<TextContents>(TextContents.Summary);

  const renderContent = () => {
    switch (content) {
      case TextContents.Summary:
        return <Summary />;
      case TextContents.List:
        return <List />;
    }
  }

  return (
    <>
    <SimpleHeader
      iconFile="icon-statistics-big.svg"
      parentMenu={t('common.menu.statistics')}
      currentMenu={t('statistics.text.title1')}
      onlyTitle={true}
    />

    <div className="content scrollbar">
      <div className="col-frame">
        <div className="comm-tab__line">
          <ul>
            <TabItem
              currentContent={content}
              onSetContent={setContent}
              tabContent={TextContents.Summary}
              tabLabel={t('statistics.attendance.Tab1')}
            />
            <TabItem
              currentContent={content}
              onSetContent={setContent}
              tabContent={TextContents.List}
              tabLabel={t('statistics.attendance.Tab2')}
            />
          </ul>
        </div>
        <div>
          {renderContent()}
        </div>
      </div>
    </div>
    </>
  );
}

export default StatisticsText;
